import { useAppState } from 'hooks/useAppState';

export const useCompetitionRequestsCount = (id: number): null | number => {
  const { competitionRequestsCountsById } = useAppState();

  return competitionRequestsCountsById.get(id) || null;
};
